import resume from '../assets/pdf/resume.pdf'
import rkdatta_1 from '../assets/png/rkdatta_image_1.jpeg'
import rkdatta_2 from '../assets/png/rkdatta_image_2.jpeg'

export const headerData = {
    name: 'Dr. Rattan K. Datta',
    title: "Director, MERIT ITI",
    desciption:"There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. ",
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    image: rkdatta_2,
    resumePdf: resume
}
